// stringExtensions.ts

declare global {
  interface String {
    cleanUpString(): string;
  }
}

// Implement the method
String.prototype.cleanUpString = function(): string {
  if (typeof this !== "string") {
    return ""; // Return an empty string if 'this' is not a string
  }
  const str = String(this);
  return str
    .replaceAll(" ", "")  // Remove unwanted characters
    .replaceAll('<p style="', '<p style="margin:0px;')  // Adjust <p> tag styles
    .replaceAll("<p><br></p>", "");  // Remove empty <p><br></p> tags
};

// Export the module to ensure it gets executed
export {};